import React from "react";
import { useTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";
import {
  Button,
  Modal,
  ModalContent,
  ModalDescription,
} from "semantic-ui-react";
import { getSubdomain } from "../../config/StylesheetInjector";
import imageRegistry from "../../constants/imageRegistry";
import CustomHeader from "../shared/CustomHeader";

const WelcomBack = ({ handleClose, handleOpen, open }) => {
  const sub = getSubdomain();

  const { t } = useTranslation("common");

  const beforeInjection = (svg) => {
    svg.setAttribute("width", "60");
    svg.setAttribute("height", "60");
  };

  return (
    <Modal
      onClose={() => handleClose()}
      onOpen={() => handleOpen()}
      open={open}
      size="mini"
      className="welcome__back"
    >
      <ModalContent>
        <ModalDescription>
          <div className="close__logo">
            <ReactSVG onClick={handleClose} src={imageRegistry.closeLogo} />
          </div>
          <div className="fleet__logo">
            <ReactSVG
              beforeInjection={beforeInjection}
              src={imageRegistry[`${sub}_short`]}
            />
          </div>
          <CustomHeader
            title={t("welcomeBackToSetting")}
            className="dialog-subtitle"
          />

          <div className="action__btn">
            <Button onClick={handleClose} className="lets__go">
              {t("letsGo")}
            </Button>
          </div>
        </ModalDescription>
      </ModalContent>
    </Modal>
  );
};

export default WelcomBack;
